import { useEffect, useRef } from "react";

// Calls `fn` every `intervalMs` while the browser tab is visible.
// Always invokes the latest `fn` (no need to memoize it). Pass `enabled=false`
// to pause. `fn` should do a *silent* reload (no spinner / loading bar).
const useAutoRefresh = (fn, intervalMs = 5000, enabled = true) => {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    if (!enabled) return undefined;
    const id = setInterval(() => {
      if (document.visibilityState === "visible") fnRef.current();
    }, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs, enabled]);
};

export default useAutoRefresh;
